<template>

    <div class="obg" v-if="show">

        <div class="tuto-content tuto-content-left">

            <img class="obg-foxy-glasses" src="/img/foxy/glasses.svg" alt="foxy's glasses">

            <span class="obg-text">{{ $t('tuto_welcome_2_text_1') }}</span>

            <span class="obg-text">{{ $t('tuto_welcome_2_text_2') }}</span>

        </div>

        <div class="tuto-content tuto-content-right">

            <img class="img-empty" src="/img/icons/fake-circle.png">

        </div>

        <button class="btn btn-obg" @click="close">{{ $t('global_cta') }}</button>

    </div>

</template>

<script>

import Tag from '@/modules/tag'

export default {

    name: 'overlay-tuto-list',

    data () {
        return {
            show: false
        }
    },

    methods: {

        open () {
            this.show = true
            Tag.popupAmplitude(this, 'tuto_2')
        },

        close () {

            Tag.clickAmplitude(this, 'tuto_2_ok')
            Tag.clickGA(this, 'tuto_3_2_next')
            this.$emit('close')
            this.show = false
        }
    }

}
</script>

<style scoped lang="scss">

    .obg {
        background-color: $midnight;
        opacity: 0.96;
        height: 100vh;
        display: flex;
        flex-direction: row;
    }

    .tuto-content {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .tuto-content-right {
        max-width: 91px;
    }

    .img-empty {
        width: 91px;
        margin-top: 125px;
        object-fit: contain;
    }

    .obg-foxy-glasses {
        width: 64px;
        height: 64px;
        margin-top: 30px;
        margin-left: 16px;
    }

    .obg-text {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        color: #ffffff;
        text-align: left;
        margin-top: 40px;
        margin-left: 16px;
    }

    .btn-obg {
        position: fixed;
        bottom: 20px;
        right: 16px;
        width: 64px;
        height: 40px;
        background-color: #ffffff;
    }

</style>
